import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 45;
          seconds = 30;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 px-4 sm:px-6 bg-brand-ivory border-y-4 border-brand-gold/30 scroll-mt-2" data-id="element-113">
      <div className="text-center mb-6" data-id="element-114">
        <p className="text-sm font-button font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-115">
          OFFRE SPÉCIALE — SYSTÈME COMPLET 6-EN-1
        </p>
        <p className="text-base font-bold text-brand-title mb-3 leading-tight max-w-md mx-auto" data-id="element-116">
          Accédez dès aujourd'hui au système qui transformera votre façon de
          préparer et d'enseigner vos cours de danse.
        </p>
        <div className="inline-block bg-brand-rose text-white px-4 py-1.5 rounded-md shadow-sm mb-4" data-id="element-117">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-118">
            💃 DANCE PRO™ — Système 6-en-1
          </p>
        </div>
        <img src="https://cdn.magicpatterns.com/uploads/6ttQVA2xKvg2v8M78gnpQ7/ChatGPT-Image-8-jul-2026_-07_50_06-p.m..webp" alt="DANCE PRO - Box Set" className="w-full max-w-[260px] mx-auto object-contain drop-shadow-xl mb-4" data-id="element-119" />
      </div>

      <div className="bg-white border-4 border-brand-gold rounded-xl p-5 text-center relative mb-4 shadow-2xl" data-id="element-120">
        <div className="mb-4" data-id="element-121">
          <p className="text-base font-bold text-brand-text/70 mb-1" data-id="element-122">
            Prix habituel : <span className="line-through" data-id="element-123">97 $</span>
          </p>
          <p className="text-lg font-button font-bold text-red-600 mb-2 uppercase tracking-wide" data-id="element-124">
            🔥 OFFRE DE LANCEMENT — 72 % DE RÉDUCTION
          </p>
          <p className="text-6xl font-heading font-bold text-brand-title mb-1 leading-none" data-id="element-125">
            27 €
          </p>
          <p className="text-xs font-bold text-brand-text/60 uppercase tracking-wider mt-2" data-id="element-126">
            Payez en toute sécurité dans votre devise locale.
          </p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-5" data-id="element-127">
          <p className="text-sm font-bold text-red-600 mb-2 uppercase tracking-tight" data-id="element-128">
            🔥 Attention : cette offre spéciale disparaîtra lorsque le compteur
            atteindra zéro.
          </p>
          <div className="flex justify-center gap-3" data-id="element-129">
            <div className="text-center" data-id="element-130">
              <div className="bg-brand-title text-white text-2xl font-bold px-3 py-1.5 rounded-md shadow-inner leading-none" data-id="element-131">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-brand-text mt-1 tracking-wider" data-id="element-132">
                HEURES
              </p>
            </div>
            <div className="text-2xl font-bold text-brand-title mt-1" data-id="element-133">:</div>
            <div className="text-center" data-id="element-134">
              <div className="bg-brand-title text-white text-2xl font-bold px-3 py-1.5 rounded-md shadow-inner leading-none" data-id="element-135">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-brand-text mt-1 tracking-wider" data-id="element-136">
                MINUTES
              </p>
            </div>
            <div className="text-2xl font-bold text-brand-title mt-1" data-id="element-137">:</div>
            <div className="text-center" data-id="element-138">
              <div className="bg-brand-title text-white text-2xl font-bold px-3 py-1.5 rounded-md shadow-inner leading-none" data-id="element-139">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-brand-text mt-1 tracking-wider" data-id="element-140">
                SECONDES
              </p>
            </div>
          </div>
        </div>

        {/* ÚNICO BOTÓN QUE LLEVA AL CHECKOUT EXTERNO */}
        <CTAButton href="https://dance-pro-francia.impultienda.ar/checkout" data-id="element-141">
          🚀 OUI ! JE VEUX MON SYSTÈME COMPLET 6-EN-1
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm text-brand-text font-bold" data-id="element-142">
        <div className="flex items-center gap-1.5" data-id="element-143">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-144" />
          <span data-id="element-145">4,9/5 — Avis vérifiés</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-146">
          <Shield className="w-4 h-4 text-brand-rose" data-id="element-147" />
          <span data-id="element-148">Garantie 7 jours — Zéro risque</span>
        </div>
      </div>
    </section>;
}